"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dot = exports.MainContainer = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var rotationKeyframes = (0, styled_components_1.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% { margin-bottom: 0; }\n  50% { margin-bottom: 4px }\n  100% { margin-bottom: 0 }\n"], ["\n  0% { margin-bottom: 0; }\n  50% { margin-bottom: 4px }\n  100% { margin-bottom: 0 }\n"])));
var MainContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 5px;\n  display: flex;\n  align-items: flex-end;\n"], ["\n  padding: 5px;\n  display: flex;\n  align-items: flex-end;\n"])));
exports.MainContainer = MainContainer;
var Dot = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-radius: 50%;\n  width: 8px;\n  height: 8px;\n  margin: 0 3px;\n  animation: ", " 0.8s linear infinite;\n  animation-timing-function: ease-in-out;\n  ", "\n"], ["\n  border-radius: 50%;\n  width: 8px;\n  height: 8px;\n  margin: 0 3px;\n  animation: ", " 0.8s linear infinite;\n  animation-timing-function: ease-in-out;\n  ", "\n"])), rotationKeyframes, function (_a) {
    var delay = _a.delay, backgroundColor = _a.backgroundColor;
    return "\n    animation-delay: ".concat(delay, ";\n    background-color: ").concat(backgroundColor, ";\n  ");
});
exports.Dot = Dot;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=styles.js.map